import { IntlShape } from 'react-intl'
import type { Cluster } from 'typings'
import { create, each, enforce, omitWhen, test } from 'vest'
import { messages } from './messages'

function isEmptyForm(entries: string[]) {
  return entries.length === 1 && entries[0] === ''
}

function isUnique(entries: string[], entry: string) {
  return entries.filter((e) => e === entry).length === 1
}

export function validationSuite(intl: IntlShape) {
  return create(({ expressions }: Cluster) => {
    const { formatMessage: i18n } = intl
    const { validation } = messages

    omitWhen(
      () => isEmptyForm(expressions),
      () =>
        each(expressions, (expression, index) => {
          const fieldName = `expressions.${index}`
          test(fieldName, i18n(validation.required), () => {
            enforce(expression.trim()).isNotEmpty()
          })

          test(fieldName, i18n(validation.unique), () => {
            enforce(expression).condition((expression) =>
              isUnique(expressions, expression)
            )
          })

          test(fieldName, i18n(validation.operator), () => {
            enforce(expression).matches(/\=|contains/)
          })

          omitWhen(!expression.includes('='), () =>
            test(fieldName, i18n(validation.equals), () => {
              enforce(expression).matches(/^\w+=(?!\s)\S+/)
            })
          )

          omitWhen(!expression.includes('contains'), () =>
            test(fieldName, i18n(validation.contains), () => {
              enforce(expression).matches(/^\w+ contains (?!\s)\S+/)
            })
          )
        })
    )
  })
}
